import lottie from 'lottie-web'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export const beliefs = () => {
	whenever()
	// sequential()
}

const whenever = () => {

	let el = document.querySelector('[data-animation="beliefs"]')

	if (!el || window.innerWidth < 960) return false

	let strikeoutFirst = el.querySelector('[data-strikeout="1"]'),
		strikeoutSecond = el.querySelector('[data-strikeout="2"]'),
		strikeoutThird = el.querySelector('[data-strikeout="3"]')

	let animationFirst = lottie.loadAnimation({
		container: strikeoutFirst,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/strikeoutfirsta.json',
	})

	let animationSecond = lottie.loadAnimation({
		container: strikeoutSecond,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/strikeoutseconda.json',
	})

	let animationThird = lottie.loadAnimation({
		container: strikeoutThird,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/strikeoutthirda.json',
	})

	ScrollTrigger.create({
		trigger: el.parentElement.parentElement,
		start: 'top 80%',
		onEnter: () => {
			animationFirst.play()
			animationSecond.play()
			animationThird.play()
		}
	})
}

const sequential = () => {

	let el = document.querySelector('[data-animation="beliefs"]')

	if (!el || window.innerWidth < 960) return false

	let calc = el.parentElement.offsetWidth - el.offsetWidth

	let strikeoutFirst = el.querySelector('[data-strikeout="1"]'),
		strikeoutSecond = el.querySelector('[data-strikeout="2"]'),
		strikeoutThird = el.querySelector('[data-strikeout="3"]')

	let animationFirst = lottie.loadAnimation({
		container: strikeoutFirst,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/strikeoutfirsta.json',
	})

	let animationSecond = lottie.loadAnimation({
		container: strikeoutSecond,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/strikeoutseconda.json',
	})

	let animationThird = lottie.loadAnimation({
		container: strikeoutThird,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/strikeoutthirda.json',
	})

	let totalFramesFirst = animationFirst.totalFrames;
	let totalFramesSecond = animationSecond.totalFrames;
	let totalFramesThird = animationThird.totalFrames;

	const totalFrames = 149

	function lottieTween(animation) {
		return gsap.to({ frame: 0 }, {
			frame: totalFrames,
			duration: 1,
			ease: 'none',
			onUpdate: function () {
				animation.goToAndStop(this.targets()[0].frame, true)
			}
		})
	}

	let tl = gsap.timeline({
		scrollTrigger: {
			trigger: el.parentElement.parentElement,
			start: "center center",
			end: "+=3000",
			pin: true,
			scrub: true,
			// markers: true,
		}
	})

	tl.fromTo(el, {
		x: 0
	}, {
		x: calc,
		duration: 1,
		delay: 0.15,
	})

	tl.add(() => animationFirst.play(), 0)
	tl.add(() => animationSecond.play(), 0.3)
	tl.add(() => animationThird.play(), 0.6)

}

export default () => { }